module.exports = __webpack_public_path__ + "media/images/category/feature/aoj_e/aoj_e-1-e6228890950294eefa823ed0e81d856c.jpg";